import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import UserAccessNav from '../components/UserAccessNav';
import { UserContext } from '../App';
import { createUserRegistry, getUserRegistry, updateUserRegistry } from '../util/userAccessApi';

function UserAccessUserEditor() {
  const userCtx = useContext(UserContext);
  const navigate = useNavigate();
  const params = useParams();
  const isEdit = Boolean(params.userId);
  const userId = params.userId ? Number(params.userId) : null;

  const [userid, setUserid] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(isEdit);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!userCtx.user || !isEdit || userId == null || Number.isNaN(userId)) {
      return;
    }

    setLoading(true);
    setError(null);

    getUserRegistry(userId)
      .then((user) => {
        setUserid(user.userid);
        setName(user.name);
      })
      .catch((e: Error) => {
        console.error('Failed to load user for editing!', e);
        setError(e.message || 'Nepodarilo sa načítať používateľa.');
      })
      .finally(() => setLoading(false));
  }, [isEdit, userCtx.user, userId]);

  const handleSave = () => {
    if (!userCtx.user || saving) {
      return;
    }

    setSaving(true);
    setError(null);

    const operation = isEdit && userId != null
      ? updateUserRegistry(userId, { userid, name })
      : createUserRegistry({ userid, name });

    operation
      .then((savedUser) => navigate(`/userAccessUsers/${savedUser.id}`))
      .catch((e: Error) => {
        console.error('Failed to save user!', e);
        setError(e.message || 'Nepodarilo sa uložiť používateľa.');
      })
      .finally(() => setSaving(false));
  };

  return (
    <div className="flex flex-col min-h-0 h-full">
      <Header />
      <UserAccessNav />

      <div className="flex-1 overflow-auto p-6">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <h1 className="text-2xl font-bold">{isEdit ? 'Upraviť používateľa' : 'Nový používateľ'}</h1>
          <Link className="btn-secondary" to={isEdit && userId != null ? `/userAccessUsers/${userId}` : '/userAccessUsers'}>
            Späť
          </Link>
        </div>

        {!userCtx.user && <div className="mt-4">Neprihlásený!</div>}
        {userCtx.user && loading && <div className="mt-4">Načítavam...</div>}
        {userCtx.user && !loading && (
          <div className="mt-6 max-w-xl space-y-4">
            <div>
              <label htmlFor="user-userid" className="input-label">User ID</label>
              <input id="user-userid" className="input" type="text" value={userid} onChange={(e) => setUserid(e.target.value)} />
            </div>

            <div>
              <label htmlFor="user-name" className="input-label">Meno</label>
              <input id="user-name" className="input" type="text" value={name} onChange={(e) => setName(e.target.value)} />
            </div>

            {error && <div className="text-red-600">{error}</div>}

            <div className="flex gap-2">
              <button className="btn-primary" type="button" disabled={saving} onClick={handleSave}>
                {saving ? 'Ukladám...' : 'Uložiť'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserAccessUserEditor;
